// Sizes every vio-tables-v2 body (.vt2-table-scroll) to the space left on screen, so the table
// shows as many rows as fit, its horizontal scrollbar and the pagination bar stay in view, and
// extra rows scroll inside the table. Measured at runtime because the space above the table
// differs per screen and with browser zoom (a plain 100vh calc can't know either).
const MIN_BODY_PX = 140;
const BOTTOM_GAP_PX = 12;

function scrollParent(el: HTMLElement): HTMLElement {
  for (let p = el.parentElement; p && p !== document.body; p = p.parentElement) {
    const oy = getComputedStyle(p).overflowY;
    if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight + 1) return p;
  }
  return document.documentElement;
}

function fit(): void {
  document.querySelectorAll<HTMLElement>('.vt2-table-scroll').forEach((body) => {
    const card = body.closest<HTMLElement>('.vt2-card') || body.parentElement!;
    // what the card needs under the body (pagination bar, borders)
    const belowBody = Math.max(0, card.getBoundingClientRect().bottom - body.getBoundingClientRect().bottom);

    const sp = scrollParent(body);
    const isDoc = sp === document.documentElement;
    const viewTop = isDoc ? 0 : sp.getBoundingClientRect().top;
    const viewHeight = isDoc ? window.innerHeight : sp.clientHeight;
    const scrolled = isDoc ? window.scrollY : sp.scrollTop;
    // body top measured from the top of the scrolled content, so the result doesn't depend on
    // how far the page happens to be scrolled right now
    const topInContent = body.getBoundingClientRect().top - viewTop + scrolled;

    const footer = document.querySelector<HTMLElement>('app-footer, footer');
    const footerPx = isDoc && footer && getComputedStyle(footer).position === 'fixed' ? footer.offsetHeight : 0;

    const avail = viewHeight - footerPx - topInContent - belowBody - BOTTOM_GAP_PX;
    body.style.maxHeight = `${Math.max(MIN_BODY_PX, Math.floor(avail))}px`;
  });
}

export function initTableHeightFitting(): void {
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; fit(); });
  };
  window.addEventListener('resize', schedule);
  // tables appear/re-render as screens and data load
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
}
